import React, { useMemo } from 'react';
import styles from './ScreenShadow.module.scss';
import Loader from '../Loader/Loader';
import cn from 'classnames';

interface Props {
  isHidden?: boolean;
  isPositionFixed?: boolean;
}

const ScreenShadow = ({ isHidden, isPositionFixed }: Props) => {
  return useMemo(() => {
    if (!isHidden) {
      return (
        <div className={cn(styles.wrapper, isPositionFixed && styles.fixed)}>
          <Loader isHidden={isHidden} />
        </div>
      );
    }
    return null;
  }, [isHidden]);
};

export default ScreenShadow;
